import React, { Component } from "react";
import { message, Checkbox, Select } from "antd";
import axios from "axios";
import {
  Form,
  FormItem,
  InputItem,
  SelectItem,
  ButtonItem,
} from "../../../Components/Items";

const { Option } = Select;

// Alta rápida de un proveedor a partir de los datos del emisor de un XML, para poder
// resolver la relación de sus insumos sin salir de la vista donde se está revisando el XML.
// Mismos campos que ya usa LeerXml.js (Pages/Panel/LeerXml/LeerXml.js) cuando detecta un
// proveedor nuevo, y mismo endpoint que usa el alta automática por lote de
// ImportarFacturasXmlMasivo.js (proveedores/agregarProveedor).
class AltaProveedorRapida extends Component {
  formRef = React.createRef();
  state = { loading: false };

  onFinish(values) {
    this.setState({ loading: true });
    const body = { ...values, empresaId: this.props.empresaId, estado: 1 };
    axios
      .post("proveedores/agregarProveedor", body, { headers: this.props.headersToken })
      .then((res) => {
        this.setState({ loading: false });
        if (res.data.success === 2) {
          message.success("Se ha registrado un proveedor");
          this.props.onAlta({ ...body, _id: res.data.codigo, diasCredito: 0, retenciones: [] });
        } else if (res.data.success === 1) {
          message.error("No se puede registrar el proveedor");
        } else {
          message.error("Hubo un error y el proveedor no se registro");
        }
      })
      .catch(() => {
        this.setState({ loading: false });
        message.error("Hubo un error y el proveedor no se registro");
      });
  }

  render() {
    const { rfc, nombre, monedaAbrev, todasTiposDeProveedor, todasMonedas } = this.props;
    const monedaInicial = (todasMonedas || []).find(
      (m) => (m.abreviacion || "").toLowerCase() === (monedaAbrev || "").toLowerCase()
    )?._id;

    return (
      <Form
        ref={this.formRef}
        name="altaProveedorRapida"
        layout
        bottom={
          <ButtonItem type="primary" size="small" htmlType="submit">
            Registrar proveedor
          </ButtonItem>
        }
        onFinish={this.onFinish.bind(this)}
      >
        <FormItem name="persona" label="Persona Moral" valuePropName="checked" initialValue={true} margin>
          <Checkbox />
        </FormItem>
        <FormItem shouldUpdate noStyle>
          {({ getFieldValue }) =>
            getFieldValue("persona") ? (
              <FormItem label="Razon Social" margin pattern required max={200} name="razonSocial" initialValue={nombre}>
                <InputItem placeholder="Razon Social" />
              </FormItem>
            ) : (
              <FormItem label="Nombre" margin pattern required name="nombre" initialValue={nombre}>
                <InputItem placeholder="Nombre" />
              </FormItem>
            )
          }
        </FormItem>
        <FormItem
          name="pagoElectronico"
          label="Es pago electronico"
          valuePropName="checked"
          initialValue={true}
          margin
        >
          <Checkbox />
        </FormItem>
        <FormItem label="Tipo de Operación" name="tipoOperacion" required margin initialValue={3}>
          <SelectItem placeholder="Tipo de Operación">
            <Option value={1}>03 - Prestacion de servicios</Option>
            <Option value={2}>06 - Arrendamiento de inmuebles</Option>
            <Option value={3}>85 - Otros</Option>
            <Option value={4}>NA - No asignados</Option>
            <Option value={5}>02 - Enajenación de bienes</Option>
            <Option value={6}>07 - Importación de bienes o servicios</Option>
            <Option value={7}>08 - Importación por transferencia virtual</Option>
            <Option value={8}>87 - Operaciones globales</Option>
          </SelectItem>
        </FormItem>
        <FormItem label="Tipo de Tercero" name="tipoTercero" required margin initialValue={1}>
          <SelectItem placeholder="Tipo de Tercero">
            <Option value={1}>04 - Proveedor Nacional</Option>
            <Option value={2}>05 - Proveedor Extranjero</Option>
            <Option value={3}>15 - Proveedor Global</Option>
          </SelectItem>
        </FormItem>
        <FormItem label="Tipo de Proveedor" margin name="tipoProveedorId" required>
          <SelectItem placeholder="Tipo de Proveedor">
            {(todasTiposDeProveedor || []).map((t) => (
              <Option value={t._id} key={t._id}>
                {t.nombre + " - " + t.descripcion}
              </Option>
            ))}
          </SelectItem>
        </FormItem>
        <FormItem label="RFC" name="rfc" required margin rfc initialValue={rfc}>
          <InputItem placeholder="RFC" disabled />
        </FormItem>
        <FormItem label="Tipo de Moneda" name="monedaId" required margin initialValue={monedaInicial}>
          <SelectItem placeholder="Tipo de Moneda">
            {(todasMonedas || []).map((m) => (
              <Option value={m._id} key={m._id}>
                {m.nombre + " - " + m.abreviacion}
              </Option>
            ))}
          </SelectItem>
        </FormItem>
      </Form>
    );
  }
}

export default AltaProveedorRapida;
